import { configureStore } from '@reduxjs/toolkit';
import useIsServer from 'hooks/useIsServer';
import { useDispatch } from 'react-redux';
import { combineReducers } from 'redux';
import app from 'store/app/slice';
import { AppState } from 'store/app/types';
import cart from 'store/cart/slice';
import { CartState } from 'store/cart/types';
import category from 'store/category/slice';
import { CategoryState } from 'store/category/types';
import landing, { LandingState } from 'store/landing/slice';
import price from 'store/price/slice';
import { PriceState } from 'store/price/types';
import product from 'store/product/slice';
import search from 'store/search/slice';
import studioSearch from 'store/studioSearch/slice';
import globalVars from 'utils/globalVars';
import customer, { CustomerState } from './customer/slice';
import dashboard, { DashboardState } from './dashboard/slice';
import favourite, { FavouriteState } from './favourite/slice';
import publicAssetProduct from './publicAssetProduct/slice';
import { PublicAssetProductState } from './publicAssetProduct/types';
import { ProductState } from './product/types';
import { SearchState } from './search/types';
import { StudioSearchState } from './studioSearch/types';

const isServer = useIsServer();

let serverState = {};

if (!isServer) {
  // Grab the state from a global variable injected into the server-generated HTML
  serverState = window.__PRELOADED_STATE__ as Store;
  globalVars.env = (serverState as any)?.app?.env;
  // Allow the passed state to be garbage-collected
  delete window.__PRELOADED_STATE__;
}

export interface Store {
  app: AppState;
  cart: CartState;
  category: CategoryState;
  product: ProductState;
  price: PriceState;
  search: SearchState;
  studioSearch: StudioSearchState;
  landing: LandingState;
  publicAssetProduct: PublicAssetProductState;
  customer: CustomerState;
  dashboard: DashboardState;
  favourite: FavouriteState;
}

export const rootReducer = combineReducers({
  app,
  cart,
  category,
  product,
  price,
  search,
  studioSearch,
  landing,
  publicAssetProduct,
  customer,
  dashboard,
  favourite,
});

export type RootState = ReturnType<typeof rootReducer>;

const store = configureStore({
  reducer: rootReducer,
  preloadedState: serverState,
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;

export default store;
